export default __webpack_public_path__ + "static/media/investment-acquisition-2.4c3589a3.svg";